// extracted by mini-css-extract-plugin
export var wrapper = "Hit-module--wrapper--3rXB5";
export var list = "Hit-module--list--2e-HR";
export var item = "Hit-module--item--38p7B";
export var text = "Hit-module--text--3oCvQ";
export var counts = "Hit-module--counts--3Jjyg";
export var imgbox = "Hit-module--imgbox--GDSma";
export var title = "Hit-module--title--1R4zw";
export var price = "Hit-module--price--2uR7D";
export var address = "Hit-module--address--3XOSc";